import * as React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from 'src/components/ui/popover';
import { Button } from 'src/components/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from 'src/components/ui/command';
import { cn } from 'src/lib/utils';
import { clsx } from 'clsx';
import taxIdTypes from './tax_types.json';
import { specialTaxTypes } from 'src/pages/SubscriptionPage/PaymentMethod/AddPaymentMethodPopup/SelectTaxIdTypeComponentWithSearch/SpecialTaxTypes';

export function SelectTaxIdTypeComponentWithSearch({
  inputPlaceholder = 'Search',
  placeholder = 'Select Country...',
  emptyMessage = 'No Items found.',
  countryItems = [],
  setSelected = (_value?: any) => {},
  btnClassName = '',
}) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');

  const taxIdFilteredByCountry = taxIdTypes.flatMap((taxType) => {
    const country =
      specialTaxTypes[taxType] ??
      countryItems.find((item) => item.iso2.toLowerCase() === taxType.split('_')[0]);

    return country ? [{ ...country, taxType }] : [];
  });

  const dialogRoot = document.getElementById('add-payment-method-form');
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={clsx(
            btnClassName,
            'w-full justify-between text-sm font-medium font-jamjuree px-3 py-[7px] h-auto !rounded-sm-5 border-[#B8C1C666] shadow-none aria-expanded:border-green_750 hover:border-ebony',
          )}
        >
          {value ? (
            taxIdFilteredByCountry
              .find((country) => country.name === value)
              ?.taxType.split('_')
              .join(' ')
              .toUpperCase()
          ) : (
            <span className="opacity-40">{placeholder}</span>
          )}
          <ChevronDown
            width={16}
            className={clsx('transition-transform rotate-0', open && 'rotate-180')}
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[250px] p-0 z-50" container={dialogRoot}>
        <Command>
          <CommandInput placeholder={inputPlaceholder} className="h-9" />
          <CommandList>
            <CommandEmpty>{emptyMessage}</CommandEmpty>
            <CommandGroup>
              {taxIdFilteredByCountry.map((country) => (
                <CommandItem
                  key={country.taxType}
                  value={country.name}
                  onSelect={(currentValue) => {
                    setValue(currentValue === value ? '' : currentValue);
                    setOpen(false);
                    setSelected(currentValue === value ? '' : country.taxType);
                  }}
                >
                  <div className="flex gap-1 items-center">
                    {country.emoji}
                    <span className="text-nowrap">
                      {country.taxType.split('_').join(' ').toUpperCase()}
                    </span>
                    <span className="opacity-50 text-nowrap">{country.name}</span>
                  </div>
                  <Check
                    className={cn('ml-auto', value === country.name ? 'opacity-100' : 'opacity-0')}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
